import { UPDATE_VALUES } from '../actions/types';

export default function(state = null, action) {
  switch (action.type) {
    case UPDATE_VALUES:
      return action.payload
    default:
      // Form starts on step 1
      return null;
  }
}